import { request } from './request';

/**
 * 获取产品分类列表
 */
export function getCategoryList() {
  return request.get('/product/categoryList');
}

/**
 * 按照类别查询产品-分页
 * @param params - 分页参数，cid 不传值代表查询所有
 * @param params.pageNum - 页码
 * @param params.pageSize - 每页数量
 * @param params.cid - 分类ID
 */
export function getProductListByCid(params?: any) {
  return request.get('/product/pageProductListByCid', params);
}

/**
 * 根据ID获取产品详情
 * @param id - 产品ID
 */
export function getProductById(id: number) {
  return request.get(`/product/${id}`);
}

/**
 * 产品详情数据类型
 */
export interface ProductDetail {
  categoryId: number;
  id: number;
  introduce: string;
  majorParameter: string;
  name: string;
  productImage: string;
  publishTime: string;
  sortOrder: number;
}
